<template>
  <q-dialog
    :model-value="modelValue"
    persistent
    @update:model-value="emit('update:modelValue', $event)"
  >
    <q-card style="width: 500px; max-width: 80vw;">
      <q-card-section>
        <div class="text-h6">Add Level to {{ selectedBuilding?.name }}</div>
      </q-card-section>

      <q-card-section>
        <q-form @submit="onSubmit">
          <q-select
            :model-value="formData.brick_class"
            :options="levelBrickClasses"
            label="BRICK Class"
            filled
            required
            emit-value
            map-options
            class="q-mb-md"
            @update:model-value="onBrickClassUpdate"
          />
          <q-input
            :model-value="formData.name"
            label="Level Name"
            filled
            required
            class="q-mb-md"
            @update:model-value="emit('update:name', $event)"
          />
          <q-input
            :model-value="formData.level_number"
            label="Level Number"
            filled
            type="number"
            class="q-mb-md"
            @update:model-value="emit('update:level-number', $event)"
          />
          <q-input
            :model-value="formData.description"
            label="Description"
            filled
            type="textarea"
            rows="3"
            @update:model-value="emit('update:description', $event)"
          />
        </q-form>
      </q-card-section>

      <q-card-actions align="right">
        <q-btn v-close-popup flat label="Cancel" />
        <q-btn
          color="primary"
          label="Add Level"
          :loading="saving"
          @click="onSubmit"
        />
      </q-card-actions>
    </q-card>
  </q-dialog>
</template>

<script setup>
  const props = defineProps({
    modelValue: {
      type: Boolean,
      default: false,
    },
    formData: {
      type: Object,
      required: true,
    },
    selectedBuilding: {
      type: Object,
      default: null,
    },
    levelBrickClasses: {
      type: Array,
      default: () => [],
    },
    saving: {
      type: Boolean,
      default: false,
    },
  });

  const emit = defineEmits([
    'update:modelValue',
    'update:name',
    'update:brick-class',
    'update:level-number',
    'update:description',
    'update-level-defaults',
    'submit',
  ]);

  function onBrickClassUpdate(value) {
    emit('update:brick-class', value);
    emit('update-level-defaults', value);
  }

  function onSubmit() {
    emit('submit');
  }
</script>
